module.exports = __webpack_public_path__ + "5bb0609b8b7739fbdd4ff853021ce68c.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/1000_l_70.mp3
// module id = 462
// module chunks = 0